import { TwoColumnBox } from "Components/TwoColumnBox";
import { BachelorsOrMasters } from "./BachelorsOrMasters";
import { DegreeType } from "./DegreeType";
import { YearApplyingFor } from "./Year";
import { Intake } from "./Intake";
import { Flex, Form } from "antd";
import { Branch } from "./Branch";
import { useState } from "react";

export const ApplyingFor = ({ form }) => {
  const [state, setState] = useState({
    applyingProgram: form.getFieldValue("applyingProgram"),
    applyingBranch: form.getFieldValue("applyingBranch"),
    degreeType: form.getFieldValue("degreeType"),
    applyingYear: form.getFieldValue("applyingYear"),
    applyingIntake: form.getFieldValue("applyingIntake"),
  });
  return (
    <TwoColumnBox
      leftElement={
        <Flex vertical>
          <Form.Item
            name="applyingProgram"
            rules={[{ required: true, message: "Please select a program" }]}
          >
            <BachelorsOrMasters
              selectedCard={state.applyingProgram}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, applyingProgram: value };
                });
                form.setFieldsValue({
                  applyingProgram: value,
                });
              }}
            />
          </Form.Item>
          <Form.Item
            name="applyingBranch"
            rules={[{ required: true, message: "Please select a branch" }]}
          >
            <Branch
              selectedCard={state.applyingBranch}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, applyingBranch: value };
                });
                form.setFieldsValue({
                  applyingBranch: value,
                });
              }}
            />
          </Form.Item>
          {form.getFieldValue("applyingProgram") === "Masters" && (
            <Form.Item
              name="degreeType"
              rules={[{ required: true, message: "Please select a degree type" }]}
            >
              <DegreeType
                selectedCard={state.degreeType}
                setSelectedCard={(value) => {
                  setState((prev) => {
                    return { ...prev, degreeType: value };
                  });
                  form.setFieldsValue({
                    degreeType: value,
                  });
                }}
              />
            </Form.Item>
          )}
        </Flex>
      }
      rightElement={
        <Flex vertical>
          <Form.Item
            name="applyingYear"
            rules={[{ required: true, message: "Please select a year" }]}
          >
            <YearApplyingFor
              selectedCard={state.applyingYear}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, applyingYear: value };
                });
                form.setFieldsValue({
                  applyingYear: value,
                });
              }}
            />
          </Form.Item>
          <Form.Item
            name="applyingIntake"
            rules={[{ required: true, message: "Please select a intake" }]}
          >
            <Intake
              selectedCard={state.applyingIntake}
              setSelectedCard={(value) => {
                setState((prev) => {
                  return { ...prev, applyingIntake: value };
                });
                form.setFieldsValue({
                  applyingIntake: value,
                });
              }}
            />
          </Form.Item>
        </Flex>
      }
    />
  );
};
